import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Target, Moon, Sun, Menu, X } from 'lucide-react';

const Navbar = ({ isDark, setIsDark }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/70 dark:bg-black/50 backdrop-blur-xl shadow-lg shadow-black/5 dark:shadow-gold/5 border-b border-white/20 dark:border-gold/10 transition-all duration-500 rounded-b-2xl md:rounded-none px-4 sm:px-6 lg:px-8 py-2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            {/* Logo */}
            <Link to="/" className="flex-shrink-0 flex items-center cursor-pointer hover:opacity-80 transition-opacity duration-300">
              <div className="w-8 h-8 bg-gold rounded-full flex items-center justify-center">
                <span className="text-black font-display font-bold text-sm">TIP</span>
              </div>
              <span className="ml-2 text-xl font-display font-semibold uppercase tracking-wide text-gold dark:text-gold">The Super Tip</span>
            </Link>

            {/* Navigation Links */}
            <div className="hidden md:ml-6 md:flex space-x-1">
              <Link
                to="/"
                className={`px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 flex items-center space-x-2 hover:scale-105 ${
                  location.pathname === '/'
                    ? 'bg-white/30 dark:bg-black/20 text-gold shadow-lg shadow-gold/20'
                    : 'text-gray-text dark:text-gray-textdark hover:bg-white/20 dark:hover:bg-black/10 hover:text-goldlight'
                }`}
              >
                <Home className="h-4 w-4" />
                <span>Home</span>
              </Link>
              <Link
                to="/sports"
                className={`px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 flex items-center space-x-2 hover:scale-105 ${
                  location.pathname === '/sports'
                    ? 'bg-white/30 dark:bg-black/20 text-gold shadow-lg shadow-gold/20'
                    : 'text-gray-text dark:text-gray-textdark hover:bg-white/20 dark:hover:bg-black/10 hover:text-goldlight'
                }`}
              >
                <Target className="h-4 w-4" />
                <span>Sports</span>
              </Link>
            </div>
          </div>

          {/* Dark Mode Toggle and Mobile Menu Button */}
          <div className="flex items-center space-x-2">
            {/* Mobile Menu Toggle */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden bg-white/60 dark:bg-black/40 backdrop-blur-md p-2 rounded-lg hover:bg-white/20 dark:hover:bg-black/20 transition-all duration-300 border border-white/20 dark:border-white/10"
            >
              {isMenuOpen ? (
                <X className="h-6 w-6 text-gray-700 dark:text-gray-300" />
              ) : (
                <Menu className="h-6 w-6 text-gray-700 dark:text-gray-300" />
              )}
            </button>

            <button
              onClick={() => setIsDark(!isDark)}
              className="bg-white/60 dark:bg-black/40 backdrop-blur-md p-3 rounded-xl shadow-lg hover:shadow-xl shadow-yellow-500/10 hover:scale-105 transition-all duration-300 border border-white/20 dark:border-white/10"
            >
              {isDark ? <Sun className="h-5 w-5 text-yellow-400" /> : <Moon className="h-5 w-5 text-gray-700" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:hidden border-t border-white/20 dark:border-white/10 animate-in slide-in-from-top duration-300">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <Link
              to="/"
              className={`block px-3 py-2 rounded-lg text-base font-medium transition-all duration-300 flex items-center space-x-2 ${
                location.pathname === '/'
                  ? 'bg-white/30 dark:bg-black/20 text-gold shadow-lg shadow-gold/20'
                  : 'text-gray-text dark:text-gray-textdark hover:bg-white/20 dark:hover:bg-black/10 hover:text-goldlight'
              }`}
            >
              <Home className="h-4 w-4" />
              <span>Home</span>
            </Link>
            <Link
              to="/sports"
              className={`block px-3 py-2 rounded-lg text-base font-medium transition-all duration-300 flex items-center space-x-2 ${
                location.pathname === '/sports'
                  ? 'bg-white/30 dark:bg-black/20 text-gold shadow-lg shadow-gold/20'
                  : 'text-gray-text dark:text-gray-textdark hover:bg-white/20 dark:hover:bg-black/10 hover:text-goldlight'
              }`}
            >
              <Target className="h-4 w-4" />
              <span>Sports</span>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
